import { authHttp, http } from '@/api/http';
import type { LoginResponse, UserInfo } from '@/api/types';

export interface LoginRequest {
  tenant: string;
  username: string;
  password: string;
}

export const authApi = {
  login: (body: LoginRequest) => authHttp.post<LoginResponse>('/v1/auth/login', body).then((r) => r.data),
  logout: () => authHttp.post('/v1/auth/logout'),
  me: () => http.get<UserInfo>('/v1/auth/me').then((r) => r.data),
  updateLocale: (locale: string) => http.put('/v1/auth/me/preferences', { locale }),
};
